import React, {FC, useEffect, useRef, useState} from "react";
import Row from "./Row";
import {IStocksExportRuleForWarehouse} from "../../../../constants/StocksExport/IStocksExportRuleForWarehouse";
import {IStocksReserveRuleForWarehouse} from "../../../../constants/StocksReserve/IStocksReserveRuleForWarehouse";
import url from "../../../../utils/UrlHelper";
import {Link} from "react-router-dom";
import {IProductsFilter} from "../../../../api/services/sellerProductsService";


interface DataSourcesProps {
    sellerID: number,
    freeShare: number,
    isEnabledAutoExport: boolean,
    isEnabledAutoReserving: boolean,
    isDisabledAutoReserving: boolean,
    isFilteringAvailableForSLA: boolean,
    data: IStocksExportRuleForWarehouse[],
    reserveData: IStocksReserveRuleForWarehouse[],
    productFilters: IProductsFilter[],
    updateDataHandler: (data: IStocksExportRuleForWarehouse[]) => void
    updateReserveDataHandler: (data: IStocksReserveRuleForWarehouse[]) => void
}


const Rows: FC<DataSourcesProps> = ({sellerID, freeShare, isEnabledAutoExport, isEnabledAutoReserving, isDisabledAutoReserving, isFilteringAvailableForSLA, data, reserveData, productFilters, updateDataHandler, updateReserveDataHandler}) => {

    const [itemsDisclosureState, setItemsDisclosureState] = useState<{ [key: number]: boolean }>({});
    const toggleIsDisclosed = (index: number) => {
        itemsDisclosureState[index] = !itemsDisclosureState[index]

        for (const k in itemsDisclosureState) {
            if (k !== index.toString()) {
                itemsDisclosureState[k] = false
            }
        }

        setItemsDisclosureState({...itemsDisclosureState})
    }

    const onReserveRuleChange = (changedRule: IStocksReserveRuleForWarehouse) => {
        updateReserveDataHandler(reserveData.map(
            r => r.warehouseID === changedRule.warehouseID ? { ...changedRule } : r
        ));
    }

    return (
        <div>
            <table className="table-auto w-full mb-2 mt-4">
                <thead className="text-xs uppercase text-gray-400">
                <tr className="">
                    <th className="w-[45%] pr-[20px] align-vertical">
                        <div className="font-semibold text-left">Каналы</div>
                    </th>
                    <th className="w-[10%] pr-[20px] align-vertical">
                        <div className="font-semibold text-left">Учесть резерв</div>
                    </th>
                    <th className={`w-[15%] pr-[20px] align-vertical`}>
                        <div className="font-semibold text-left">С даты</div>
                    </th>
                    <th className={`w-[10%] pr-[20px] align-vertical`}>
                        <div className="font-semibold text-left">Включить отправку</div>
                    </th>
                    <th className="w-[15%] pr-[20px] align-vertical">
                        <div className="font-semibold text-right">%</div>
                    </th>
                    <th className={`w-[5%] pr-[20px] align-vertical`}></th>
                    {/*<th className="w-[10%] align-vertical">*/}
                    {/*    <div className="font-semibold text-right">Продукты</div>*/}
                    {/*</th>*/}
                </tr>
                </thead>
                <tbody className="text-sm">
                {data.map((item, key) => {
                        if (!itemsDisclosureState[key]) {
                            itemsDisclosureState[key] = false
                        }

                        const reserveRow = reserveData.filter(w => w.warehouseID === item.warehouseID)[0] || {}
                        return <Row
                            key={key}
                            index={key}
                            sellerID={sellerID}
                            isEnabledAutoExportForSeller={isEnabledAutoExport}
                            isEnabledAutoReservingForSeller={isEnabledAutoReserving}
                            isDisabledAutoReserving={isDisabledAutoReserving}
                            isFilteringAvailableForSLA={isFilteringAvailableForSLA}
                            data={item}
                            reserveData={reserveRow}
                            updateDataHandler={() => updateDataHandler(data)}
                            updateReserveDataHandler={onReserveRuleChange}
                            freeShare={freeShare}
                            isDisclosed={itemsDisclosureState[key]}
                            toggleIsDisclosed={toggleIsDisclosed}
                            productFilters={productFilters}
                        ></Row>
                    }
                )}
                </tbody>
            </table>
            <div className={`mt-4 text-sm`}>Для добавления канала отправки остатков в настройках соответствующих <Link className={`text-[#2255A1]`} to={url('/:sellerId/warehouses', sellerID)}>складов</Link> включите опцию <b>"Показать во вкладке Отправка"</b>.</div>
        </div>
    )
}

export default Rows
